/** versionCompare (en) */
const data = {
    "versionExplainer": {
        "note": "These are two separate, standalone versions. A VX activation code does NOT unlock the Elite version, and vice versa.",
        "vx": {
            "point1": "Runs on all supported watches",
            "point2": "Free trial, then unlock with a purchased code",
            "point3": "Code is bound to one device"
        },
        "elite": {
            "point1": "One-time purchase via Garmin Pay",
            "point2": "Bound to your Garmin account, not a single device",
            "point3": "Only on watches that support Garmin Pay"
        }
    }
};
export default data;
